import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import { reflectionScalarDefault } from "./reflection-scalar-default";
import { MESSAGE_TYPE } from './message-type-contract';
/**
 * Creates an instance of the generic message, using the field
 * information.
 */

export function reflectionCreate(type) {
  var msg = {};
  Object.defineProperty(msg, MESSAGE_TYPE, {
    enumerable: false,
    value: type
  });

  var _iterator = _createForOfIteratorHelper(type.fields),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      var name = field.localName;
      if (field.opt) continue;
      if (field.oneof) msg[field.oneof] = {
        oneofKind: undefined
      };else if (field.repeat) msg[name] = [];else switch (field.kind) {
        case "scalar":
          msg[name] = reflectionScalarDefault(field.T, field.L);
          break;

        case "enum":
          // we require 0 to be default value for all enums
          msg[name] = 0;
          break;

        case "map":
          msg[name] = {};
          break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return msg;
}